export default [
  {
    portalGroup: 'all.public',
    path: 'policy/:id',
    name: 'S0901View',
    component: () => import('./PgS0901View')
  }
]
